<template>
	<section
		v-if="isAuth && showNotification"
		class="fixed top-0 left-0 flex flex-col justify-center items-center h-screen w-screen bg-white/95 z-50"
	>
		<client-only>
			<BaseModal
				v-model="showModal"
				:showCloseButton="false"
				:title="$t('newLegalDocs.title')"
				@on-accept="acceptDocs"
			>
				<p class="my-4">{{ $t("newLegalDocs.info") }}</p>

				<div class="flex items-center">
					<BaseCheckbox @click="acceptDocs" class="base-checkbox-legaldocs -mr-2"></BaseCheckbox>
					<span
						class="text-sm"
						v-html="
							$t(`newLegalDocs.agreeLegalDocs`, {
								urlSzmdPrize: getDocumentUrl(LegalDocType.PRIZE_GAME, region, $i18n.locale),
							})
						"
					></span>
				</div>

				<div class="flex justify-end mt-8 mb-2">
					<BaseButton @click="acceptDocs" class="min-w-full sm:min-w-min px-12">
						{{ $t("newLegalDocs.accept") }}
					</BaseButton>
				</div>
			</BaseModal>
		</client-only>
	</section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { getDocumentUrl, LegalDocType } from "~/utils/legalDocs";

export default defineComponent({
	name: "ModalNewLegalDocs",
	props: {
		modelValue: {
			type: Boolean,
			default: false,
		},
	},
	setup() {
		const { locale } = useI18n();

		const isAuth = useState("isAuth");
		const showNotification = ref(false);
		const showModal = ref(true);
		const region = ref("HU");

		const { isSzmdVotingPage, szmdVotingInProgress, szmdPrizes } = useSzmdConfig();

		// The prize game rules only have to be accepted while there are prizes
		if (!szmdPrizes || !szmdVotingInProgress || !isSzmdVotingPage) {
			return; // Don't show modal if there are no prizes, voting is not in progress or not on voting page
		}

		// Get actual region first
		const actualRegion = useRegion.getCurrentRegion().code.toLowerCase();
		region.value = actualRegion.toUpperCase();

		function acceptDocs() {
			$fetch("/api/accept-legal-docs", {
				method: "PUT",
				body: {
					token: useCookie("token").value,
					xsrf: useCookie("XSRF-TOKEN").value,
					locale: locale.value,
					region: region.value.toLowerCase(),
				},
			})
				.then(() => {
					// Refresh user data to update is_accepted_szmd_prize status
					useAuth.updateUser();
					showNotification.value = false;
				})
				.catch((error) => {
					console.error("Error accepting legal docs:", error);
				});
		}

		function getLegalDocsStatus() {
			const user = useAuth.getUser();
			const regionKey = region.value.toLowerCase();

			if (isAuth.value == true && user.is_accepted_szmd_prize?.[regionKey] !== true) {
				showNotification.value = true;
			}
		}

		watch(isAuth, (val: boolean) => {
			if (val == true) {
				setTimeout(() => {
					getLegalDocsStatus();
				}, 1500);
			}
		});

		onMounted(() => {
			isAuth.value == true && getLegalDocsStatus();
		});

		return {
			isAuth,
			region,
			showNotification,
			showModal,
			acceptDocs,
			getDocumentUrl,
			LegalDocType,
		};
	},
});
</script>
